// extracted by mini-css-extract-plugin
export var standaloneTable = "_hr-0";
export var standaloneTableWithBodyFill = "_hr-1";
export var withExtraHeader = "_hr-2";